import { render, staticRenderFns } from "./MessageShow.vue?vue&type=template&id=1ab74955"
import script from "./MessageShow.vue?vue&type=script&lang=js"
export * from "./MessageShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports